import PORTAL from "../portals/config.js";
import i18n from "../../i18n"

export default [
  {
    value: "orderReceived",
    label: i18n.t("orderStatus.orderReceived"),
    filterDefault: true
  },
  {
    value: "houseApprovalNeeded",
    label: i18n.t("orderStatus.houseApprovalNeeded"),
    filterDefault: true
  },

  {
    value: "forwardedToInstaller",
    label: i18n.t("orderStatus.forwardedToInstaller", { adminName: PORTAL.admin.name }),
    filterDefault: true
  },

  {
    value: "customerFacilitationNeeded",
    label: i18n.t("orderStatus.customerFacilitationNeeded"),
    filterDefault: true
  },
  {
    value: "weatherConditioned",
    label: i18n.t("orderStatus.weatherConditioned"),
    filterDefault: true

  },
  {
    value: "gridApprovalNeeded",
    label: i18n.t("orderStatus.gridApprovalNeeded"),
    filterDefault: true
  },
  {
    value: "partsNeeded",
    label: i18n.t("orderStatus.partsNeeded"),
    filterDefault: true
  },
  {
    value: "installationAgreed",
    label: i18n.t("orderStatus.installationAgreed"),
    filterDefault: true
  },
  {
    value: "paused",
    label: i18n.t("orderStatus.paused"),
    filterDefault: true
  },
  {
    value: "other",
    label: i18n.t("orderStatus.other"),
    filterDefault: true
  },
  {
    value: "completed",
    label: i18n.t("orderStatus.completed"),
    filterDefault: false
  },
  {
    value: "revoked",
    label: i18n.t("orderStatus.revoked"),
    filterDefault: false
  },
  {
    value: "deleted",
    label: i18n.t("orderStatus.deleted"),
    filterDefault: false
  },
  {
    value: "past",
    label: i18n.t("orderStatus.past"),
    filterDefault: false
  }
]


